import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Nothing-here block for lists and sections: quiet hairline top, short title,
 * one supporting sentence (`children`), optional action underneath.
 */
export function EmptyState({
  title,
  children,
  action,
  className,
}: {
  title: string
  children?: ReactNode
  action?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('border-t border-rule/60 py-14 text-center', className)}>
      <p className="text-[0.9375rem] font-medium text-ink">{title}</p>
      {children ? (
        <p className="mx-auto mt-1.5 max-w-sm text-sm leading-relaxed text-mute">{children}</p>
      ) : null}
      {action ? <div className="mt-5 flex justify-center gap-3">{action}</div> : null}
    </div>
  )
}
